export default class CartAlreadyBookedError extends Error {
  constructor(public orderId: string) {
    super(`Cart with order ID ${orderId} has been booked.`)
  }
}
